import { Badge } from "@/components/ui/badge";

const StatusBadge = ({ status }: { status: string }) => {
  return <Badge variant="outline">{status}</Badge>;
};

export default StatusBadge;
